"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.map");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Modal = _interopRequireWildcard(require("./Modal.styled"));

var _index = _interopRequireDefault(require("../Icons/obsolete/index"));

var _Screen = require("../layout/Screen/Screen.styled");

var _PrimaryButton = _interopRequireDefault(require("../Buttons/PrimaryButton/PrimaryButton.styled"));

var _utils = require("../utils");

var _utilities = require("../GlobalStyle/utilities/utilities.styled");

var _componentAnalytics = require("../Components/ComponentAnalytics/componentAnalytics");

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Modal = function Modal(props) {
  (0, _react.useEffect)(function () {
    (0, _componentAnalytics.trackMe)("LegacyModal");
  }, []);
  var open = props.open,
      onClose = props.onClose,
      onOpen = props.onOpen,
      trigger = props.trigger,
      mobileFullScreen = props.mobileFullScreen,
      isConfirmation = props.isConfirmation,
      closeButtonLabel = props.closeButtonLabel,
      size = props.size,
      isClosable = props.isClosable,
      closeOnDimmerClick = props.closeOnDimmerClick,
      children = props.children;

  var _useState = (0, _react.useState)(!1),
      show = _useState[0],
      setShow = _useState[1];

  var _useState2 = (0, _react.useState)(null),
      originalButton = _useState2[0],
      setOriginalButton = _useState2[1];

  (0, _react.useEffect)(function () {
    setShow(!0 === open ? !0 : !1);
  }, [open]);
  var modalRef = (0, _react.useRef)(null);
  var keyListenersMap = new Map([[27, function onEscClose() {
    isClosable && closeModal();
  }], [9, function handleTabKey(e) {
    var focusableElems = (0, _utils.getFocusableElement)(modalRef.current);
    (0, _utils.trapTabKey)(e, focusableElems);
  }]]);
  (0, _react.useEffect)(function () {
    var keyListener = function keyListener(e) {
      var listener = keyListenersMap.get(e.keyCode);
      return listener && listener(e);
    };

    if (show) {
      var modalElem = (0, _utils.getFocusableElement)(modalRef.current);

      if (modalElem.length) {
        modalElem.first.focus();
      }

      document.addEventListener("keydown", keyListener);
    } else {
      document.removeEventListener("keydown", keyListener);
    }

    return function () {
      return document.removeEventListener("keydown", keyListener);
    };
  }, [show]); // eslint-disable-line

  var closeModal = function closeModal() {
    setShow(!1);
    originalButton && originalButton.focus();
    onClose && onClose();
  };

  var handleDismissClick = function handleDismissClick() {
    closeModal();
  };

  var childrenNode = _react.default.Children.map(children, function (child) {
    if (!child) {
      return;
    }

    var childElem;

    if ("string" == typeof child.type) {
      childElem = /*#__PURE__*/_react.default.cloneElement(child);
    } else {
      childElem = /*#__PURE__*/_react.default.cloneElement(child, {
        hideModal: handleDismissClick
      });
    }

    return childElem;
  });

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, trigger && /*#__PURE__*/_react.default.createElement(_Modal.TriggerWrapper, {
    onClick: function showModal(e) {
      e.stopPropagation();
      setShow(!0);
      setOriginalButton(document.activeElement);
      onOpen && onOpen();
    }
  }, trigger), show && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Screen.FullScreenOpac, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    "data-opac": "stuff"
  }), /*#__PURE__*/_react.default.createElement(_Screen.FullScreen, {
    "data-fullscreen": "test",
    onClick: function onClick(e) {
      e.stopPropagation();
      closeOnDimmerClick && handleDismissClick();
    }
  }, /*#__PURE__*/_react.default.createElement(_Modal.default, {
    role: "dialog",
    "aria-modal": "true",
    ref: modalRef,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    mobileFullScreen: mobileFullScreen && mobileFullScreen ? !0 : !1,
    size: size
  }, childrenNode, isConfirmation && /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, null, /*#__PURE__*/_react.default.createElement(_Modal.default.ConfirmationButton, {
    onClick: handleDismissClick
  }, "OK, I understand")), closeButtonLabel && /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, null, /*#__PURE__*/_react.default.createElement(_PrimaryButton.default, {
    onClick: handleDismissClick
  }, closeButtonLabel)), isClosable && /*#__PURE__*/_react.default.createElement(_Modal.default.DismissButton, {
    type: "button",
    onClick: handleDismissClick,
    "data-test": "modal-close-button"
  }, /*#__PURE__*/_react.default.createElement(_index.default.Cross, null), /*#__PURE__*/_react.default.createElement(_utilities.SROnly, null, "Close"))))));
};

Modal.propTypes = {
  open: _propTypes.default.bool,
  isClosable: _propTypes.default.bool,
  closeOnDimmerClick: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  trigger: _propTypes.default.node,
  children: _propTypes.default.node,
  mobileFullScreen: _propTypes.default.bool,
  isConfirmation: _propTypes.default.bool,
  closeButtonLabel: _propTypes.default.string,
  size: _propTypes.default.string,
  onOpen: _propTypes.default.func
};
Modal.Header = _Modal.default.Header;
Modal.Body = _Modal.default.Body;
Modal.Footer = _Modal.default.Footer;
Modal.Footer.propTypes = {
  justifyContent: _propTypes.default.string
};
Modal.defaultProps = {
  isClosable: !0,
  closeOnDimmerClick: !0
};
var _default = Modal;
exports.default = _default;